module.exports = __webpack_public_path__ + "img/object_utilyy.33805904.svg";